import React, { useCallback, useContext, useEffect, useState } from 'react';
import Select from 'react-select';
import axios from 'axios';
import PageTitle from '../../Components/PageTitle';
import { ConfigContext } from '../../Context/ConfigContext';
import { formatDate, SubmitButton } from '../../Components/InputElements';
import { NoRecords } from '../../Components/Shimmer';
import Swal from 'sweetalert2';
import * as XLSX from 'xlsx'
import { decodeData,currentDateAndTime, monthData } from '../../Constants/constants';
import { debounce } from 'lodash';
import { useLocation } from 'react-router-dom';

const TeamLeavesBalance = () => {
    const { apiURL, apiHeaderFile, apiHeaderJSON, permissions,setPermissions } = useContext(ConfigContext);
    const locationParam = useLocation();
    const queryParams = new URLSearchParams(locationParam.search);
    const encodedData = queryParams.get("abs");
    const decodedData = encodedData ? decodeData(encodedData,permissions) : [];
    const [loading, setLoading] = useState(false);
    const [loadingFilter, setLoadingFilter] = useState(false);
    const [teamLeavesBalance, setTeamLeavesBalance] = useState([]);
    const [teamEmployeesList, setTeamEmployeesList] = useState([]);
    const [pagination, setPagination] = useState({
        next: false,
        prev: false,
        page: 1,
        limit: 10,
        total_records: 0,
        total_pages: 0,
        loadingList: false
    });
    const [isChanged, setIsChanged] = useState(false);
    const [filterData, setFilterData] = useState({
        employee: "",
        selected_employee_id: "",
        empOptions: [],
        yearsOptions: [],
        leaveTypeOptions: [],
        year: "",
        leaveType: "",
        month: "",

    });
    const monthOptions = [
        { value: 1, label: "Jan" },
        { value: 2, label: "Feb" },
        { value: 3, label: "Mar" },
        { value: 4, label: "Apr" },
        { value: 5, label: "May" },
        { value: 6, label: "Jun" },
        { value: 7, label: "Jul" },
        { value: 8, label: "Aug" },
        { value: 9, label: "Sep" },
        { value: 10, label: "Oct" },
        { value: 11, label: "Nov" },
        { value: 12, label: "Dec" }
    ]
    const [errors, setErrors] = useState({

    });

    const getList = () => {
        setLoadingFilter("1");
        const headers = apiHeaderJSON;
        let date = currentDateAndTime();
        axios.get(`${apiURL}Home/GetLeaveBalanceReport`, {
            params: {
                employee_id: filterData?.selected_employee_id,
                year: filterData?.year,
                leave_type_id: filterData?.leaveType,
                date: date
            },
            headers,
        })
            .then((response) => {

                var data = response.data;
                console.log("getList ~ data", data);
                if (response.data.success === true) {
                    setTeamLeavesBalance(data?.data);
                    // setPagination({
                    //     ...pagination,
                    //     next: data.next,
                    //     prev: data.prev,
                    //     page: data.page,
                    //     total_records: data.total_records,
                    //     total_pages: data.total_pages,
                    //     loadingList: false,
                    // });
                } else {
                    setTeamLeavesBalance([]);
                    // setPagination({
                    //     ...pagination,
                    //     loadingList: false,
                    // });
                }
                setLoadingFilter(false);
            })
            .catch((error)=>{
                setLoadingFilter(false);
            });
    };

    const getCurrentBalance = () => {
        setLoadingFilter("1");
        const headers = apiHeaderJSON;
        let date = currentDateAndTime();
        axios.get(`${apiURL}Approver/GetCurrentLeaveBalanceReport`, {
            params: {
                employee_id: filterData?.selected_employee_id,
                year: filterData?.year,
                leave_type_id: filterData?.leaveType,
                date: date
            },
            headers,
        })
            .then((response) => {

                var data = response.data;
                console.log("getList ~ data", data);
                if (response.data.success === true) {
                    setTeamLeavesBalance(data?.data);
                     
                } else {
                    setTeamLeavesBalance([]);
                    
                }
                setLoadingFilter(false);
            })
            .catch((error)=>{
                setLoadingFilter(false);
            });
    };


    const handleExcelDownload = () => {
        const headers = apiHeaderJSON;
        let date = currentDateAndTime();
        // console.log("handleExcelDownload ==>>", filterData?.selected_employee_id, filterData?.year, filterData?.leaveType, date);
        Swal.fire({
            title: 'Please wait...',
            html: 'Your file is being prepared for download.',
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });
        axios.get(`${apiURL}Home/GetLeaveBalanceReport`, {
            params: {
                employee_id: filterData?.selected_employee_id,
                year: filterData?.year,
                leave_type_id: filterData?.leaveType,
                date: date,
                is_employee: 0,
            },
            headers,
        }).then((response) => {
            if (response.data.success === true) {
                const rows = response?.data?.data;
                const data = rows?.map(row => ({
                    'Employee Name': row?.employee_name,
                    'Employee Code': row?.employee_code,
                    'Leave Type': row?.leave_type_name || "",
                    'Month': `${monthData[parseInt(row?.month)]}-${row?.year}`,
                    'Opening Balance': row?.opening_balance || '---',
                    'Leaves Accrued': row?.leave_accrued || '---',
                    'Leaves Taken': row?.leave_taken || '---',
                    'Closing Balance': row?.closing_balance || '---',
                }));


                const columns = [
                    { header: 'Employee Name', key: 'Employee Name', width: 20 },
                    { header: 'Employee Code', key: 'Employee Code', width: 14 },
                    { header: 'Leave Type', key: 'Leave Type', width: 12 },
                    { header: 'Month', key: 'Month', width: 10 },
                    { header: 'Opening Balance', key: 'Opening Balance', width: 14 },
                    { header: 'Leaves Accrued', key: 'Leaves Accrued', width: 13 },
                    { header: 'Leaves Taken', key: 'Leaves Taken', width: 12 }, 
                    { header: 'Closing Balance', key: 'Closing Balance', width: 13 },
                ];
                


                const wb = XLSX.utils.book_new();


                const ws = XLSX.utils.json_to_sheet(data, { header: columns.map(column => column.header) });


                ws['!cols'] = columns.map(column => ({ wch: column.width }));


                XLSX.utils.sheet_add_json(ws, data, { skipHeader: true, origin: 'A2' });


                columns.forEach((column, index) => {
                    ws[XLSX.utils.encode_cell({ r: 0, c: index })] = { v: column.header };
                });


                XLSX.utils.book_append_sheet(wb, ws, 'Team Leaves Balance Report');


                XLSX.writeFile(wb, `${rows[0].employee_name}_LeaveBalanceReport.xlsx`);


                Swal.close();


                Swal.fire({
                    title: '<strong>Success</strong>',
                    html: 'Your file has been downloaded successfully.',
                    icon: 'success'
                });
            } else {

                Swal.close();

                Swal.fire({
                    title: '<strong>Error</strong>',
                    html: response.data.message,
                    icon: 'error'
                });
            }
        })
            .catch((error) => {
                Swal.close();

                Swal.fire({
                    title: '<strong>Error</strong>',
                    html: error.message,
                    icon: 'error'
                });
            });
    }

    const getLeaveTypeList = (typelist = 0) => {
        const headers = apiHeaderJSON;
        let date = currentDateAndTime();
        axios.get(`${apiURL}Home/GetLeaveTypeListSandbox`, { params: { date: date, typelist: typelist }, headers })
            .then((response) => {
                var data = response.data;
                if (response.data.success === true) {
                    console.log("GetLeaveTypeList ~ data?.data", data?.data);
                    let leave_list_response = data?.data?.filter(val => val?.leave_hide == '0') || [];
                    let leave_list = leave_list_response?.map((row) => ({
                        value: row.leave_type_id,
                        label: row.leave_type_name
                    }));
                    setFilterData({
                        ...filterData,
                        leaveTypeOptions: leave_list
                    })
                }
            });
    }

    useEffect(() => {
        getCurrentBalance();
        getLeaveTypeList();
        getTeamEmployeesList();

    }, []);

    const getEmployeesYears = () => {
        const headers = apiHeaderJSON;
        axios
            .get(`${apiURL}Home/GetYearsList`, { params: { employee_id: filterData?.selected_employee_id }, headers })
            .then((response) => {
                // console.log("getEmployeesYears ~ response", response);
                if (response.data.success === true) {
                    let years_list = response?.data?.data?.map((row) => {
                        return (
                            { value: row, label: row }
                        )
                    });
                    // console.log("years => ", years_list);
                    setFilterData((prevFilterData) => ({
                        ...prevFilterData,
                        yearsOptions: years_list,
                    }));
                } else {
                    setFilterData((prevFilterData) => ({
                        ...prevFilterData,
                        yearsOptions: [],
                    }));
                }
            }).catch((error) => {
                console.error("Error fetching years list:", error);
                setFilterData((prevFilterData) => ({
                    ...prevFilterData,
                    yearsOptions: [],
                }));
            });

    }
    
    useEffect(() => {
        if (filterData?.year && !filterData?.yearsOptions.some(option => option.value === filterData?.year)) {
            setFilterData((prevFilterData) => ({
                ...prevFilterData,
                year: "",
                leaveType: ""
            }));
        }
    }, [filterData?.yearsOptions]);

    useEffect(() => {
        if (filterData?.selected_employee_id) {
            getEmployeesYears();
        }
    }, [filterData?.selected_employee_id])

    // const getEmployeesOptionList = async () => {
    //     const headers = apiHeaderJSON;
    //     axios
    //         .get(`${apiURL}Home/GetEmployeesOptionList`, { params: { keyword: filterData?.employee }, headers })
    //         .then((response) => {
    //             console.log("getEmployeesOptionList ~ response.data.data", response.data.data);
    //             if (response.data.success === true) {
    //                 setFilterData({ ...filterData, empOptions: response.data.data, })
    //             } else {
    //                 setFilterData({ ...filterData, empOptions: [], })
    //             }
    //         }).catch((error) => {
    //             console.log("error", error)
    //         });
    // }

    // Debounce the getEmployeesOptionList function
    
    const getTeamEmployeesList = () => {
        const headers = apiHeaderJSON;

        axios.get(`${apiURL}Approver/GetMyTeamEmployees`, {
            params: {
                limit: 10000,
                page: 1,
            },
            headers,
        })
            .then((response) => {
                var data = response.data;
                if (response.data.success === true) {
                    const temp= data?.data?.map((val)=>{
                        return {value: val?.employee_id, label: `${val?.employee_code} ${val?.employee_name}`}
                    });
                    // console.log("temp ======================>>>>>>>>>>>>>",temp);
                    setTeamEmployeesList(temp);
                } 
            });
    };
    
    // const debouncedGetEmployeesOptionList = debounce(() => {
    //     getEmployeesOptionList();
    // }, 300);

    // Effect to call debounced function when filterData changes
    // useEffect(() => {
    //     if (filterData?.employee) {
    //         debouncedGetEmployeesOptionList();
    //     }

    //     // Clean up the debounce on unmount to prevent memory leaks
    //     return () => {
    //         debouncedGetEmployeesOptionList.cancel();
    //     };
    // }, [filterData?.employee]);


    const handleClearAll = () => {
        setFilterData((prevFilterData) => (
            {
                ...prevFilterData,
                employee: "",
                selected_employee_id: "",
                year: "",
                leaveType: "",
                yearsOptions: [],
                leaveTypeOptions: [],
            })
        );
        setTeamLeavesBalance([]);
    };


    const handleInputSearch = (e) => {
        getList();
    }

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFilterData({ ...filterData, [name]: value });
    }

    const handleSelectChange = (name, selectedOption) => {
        // console.log(name, selectedOption);
        setFilterData({
            ...filterData,
            [name]: selectedOption.value,
        });
        setErrors({
            ...errors,
            [name]: "",
        })
    };

    const handlePrev = (ev) => {

        if (pagination?.prev === true) {
            setPagination({
                ...pagination,
                prev: pagination?.prev - 1
            });
        }
    }
    const handleNext = () => {

        if (pagination?.next === true) {
            setPagination({
                ...pagination,
                next: pagination?.next + 1
            });

        }
    }
    const handleChange = (e) => {
        setPagination({
            ...pagination,
            page: parseInt(e.target.value, 10)
        });
    }
    const handleLimitChange = (e) => {
        setPagination(
            {
                ...pagination,
                limit: parseInt(e.target.value, 10),
                page: 1,
            }
        );
    };
    // console.log("filterData?.selected_employee_id, filterData?.empOptions, teamEmployeesList", filterData?.selected_employee_id, filterData?.empOptions, teamEmployeesList)
    return (
        <>
            {!loading ?
                <div class="main-content" >
                    <div class="page-content">
                        <div className="container-fluid">
                            <br />
                            <PageTitle title={`Team Leave Balance`} primary={`Team Employees`} path={`/TeamEmployees`} />
                            <div className="card">
                                <div className="card-body">
                                    {/* leave balance report filter */}
                                    {/* <div className="row">
                                        <div className='col-md-3 position-relative mb-5'>
                                            <label >Employee Name or Code</label>
                                            <div style={{ "zIndex": 10, "width": "90%" }} className='   position-absolute'>
                                                  <div className="input-group">
                                                <input type="search" className="form-control" onChange={handleInputChange} name="keyword" value={filterData?.keyword} aria-label="Recipient's username" aria-describedby="button-addon2" placeholder="Search by Name" />
                                                <button className="btn btn-success" onClick={handleInputSearch} type="button" id="button-addon2"><i className="ri-search-line"></i></button>
                                            </div>  
                                                  <label htmlFor="Employee" className="form-label" > Search & Select Reporting Manager </label>  
                                                <Select onChange={(selectedOption) => handleSelectChange("selected_employee_id", selectedOption) }
                                                options={teamEmployeesList}
                                                placeholder={"Search here..."}
                                                value={ filterData?.selected_employee_id ? teamEmployeesList.find(option => option.value == filterData?.selected_employee_id) : null }/>
                                            </div>
                                        </div>
                                        <div className='col-md-2 position-relative mb-5'>
                                            <div><label>Year</label></div>
                                            <div style={{ "zIndex": 9, "width": "90%" }} className=' position-absolute'>
                                                <Select onChange={(selectedOption) => handleSelectChange("year", selectedOption)}
                                                options={filterData?.yearsOptions}
                                                placeholder="Select Year"
                                                value={ filterData?.year ? filterData?.yearsOptions.find(option => option.value === filterData?.year) : null }
                                                isDisabled={!filterData?.selected_employee_id}/>
                                            </div>
                                        </div>
                                        <div className='col-md-2 position-relative mb-5'>
                                            <div><label>Leave Type</label></div>
                                            <div style={{ "zIndex": 8, "width": "90%" }} className='  position-absolute'>
                                                <Select  onChange={(selectedOption) => handleSelectChange("leaveType", selectedOption)}
                                                options={filterData?.leaveTypeOptions}
                                                placeholder="Select Leave"
                                                value={filterData?.leaveType ? filterData?.leaveTypeOptions.find(option => option.value === filterData?.leaveType) : ""}
                                                // styles={customStyles}
                                                isDisabled={!filterData?.year}/>
                                            </div>
                                        </div>
                                        <div className='col-lg-2 col-md-3 col-6 '>
                                            <div><label>Apply Filter</label></div>
                                            {/* <button
                                                type="button"
                                                onClick={handleInputSearch}
                                                className={`w-100 btn btn-info btn-label waves-effect waves-light ${(filterData?.selected_employee_id && filterData?.year && filterData?.leaveType) ? '' : 'disabled'}`}>
                                                <i className=" ri-filter-3-fill label-icon align-middle fs-16 me-2" />
                                                Filter
                                            </button>  
                                            <SubmitButton otherClasses='w-100 noWrap' onClick={()=>{getList();}} 
                                            disabled={!filterData?.selected_employee_id && !filterData?.year && !filterData?.leaveType}
                                            loading={loadingFilter==="1"} loadingMessage='Loading' 
                                            buttonName={"Filter"}  type='info' icon='ri-filter-3-fill' />
                                        </div>
                                        <div className='col-lg-2 col-md-3 col-6 '>
                                            <div><label>Clear Filter</label></div>
                                            {/* <button
                                                type="button"
                                                className={`btn btn-secondary btn-label waves-effect waves-light noWrap ${(filterData?.selected_employee_id && filterData?.year && filterData?.leaveType) ? '' : 'disabled'}`}
                                                onClick={handleClearAll}
                                            >
                                                <i className=" ri-database-2-line  label-icon align-middle fs-16 me-2 "></i> 
                                                Clear
                                            </button>  
                                            <SubmitButton otherClasses='w-100 noWrap' onClick={()=> handleClearAll()} 
                                            disabled={!filterData?.selected_employee_id && !filterData?.year && !filterData?.leaveType}
                                            loading={loadingFilter==="2"} loadingMessage='Loading'
                                            buttonName={"Clear"}  type='secondary' icon='ri-database-2-line' />
                                        </div>
                                        {decodedData?.includes(6) && (
                                        <div className='col-lg-2 col-md-3 col-6 '>
                                            <div><label>Export Excel</label></div>
                                            {/* <button
                                                type="button"
                                                onClick={handleExcelDownload}
                                                className={`${teamLeavesBalance?.length === 0 ? ('disabled') : ""} btn btn-success btn-label waves-effect waves-light noWrap`}>
                                                <i className="ri-file-excel-line label-icon align-middle fs-16 me-2" />
                                                Export Excel
                                            </button>  
                                            <SubmitButton otherClasses='w-100 noWrap' onClick={()=>{ handleExcelDownload() }} 
                                            disabled={teamLeavesBalance?.length === 0}
                                            buttonName={"Export Excel"}  type='success' icon='ri-file-excel-2-line' />
                                        </div>)}
                                    </div> */}
                                    {/* leave balance report table */}
                                    <div className="col-lg-12 mt-4">
                                        <div className='card '>
                                            <div style={{ "maxHeight": "65vh", "overflowY": "auto", "overflowX": "auto" }}>
                                                {/* <table className=" position-relative table table-borderless table-hover align-middle mb-0 table-bordered table-stripped">
                                                    <thead className="bg-primary text-light bg-gradient sticky-top z-1">
                                                        <tr>
                                                            <th className=' noWrap'>Sr. No.</th>
                                                            <th className=' noWrap'>Month</th>
                                                            <th className=' noWrap'>Opening Balance</th>
                                                            <th className=' noWrap'>Leave Accrued</th>
                                                            <th className=' noWrap'>Leaves Taken</th>
                                                            <th className=' noWrap'>Closing Balance</th>
                                                        </tr>
                                                    </thead>
                                                    {teamLeavesBalance?.length === 0 ?
                                                        <tbody>
                                                            <tr>
                                                                <td colSpan={11}>
                                                                    <NoRecords />
                                                                </td>
                                                            </tr>
                                                        </tbody> :
                                                        <tbody className=' text-center'>
                                                            {teamLeavesBalance?.map((row, idx) => {
                                                                // console.log(row?.year);
                                                                return (
                                                                    <tr>
                                                                        <td>{idx + 1}</td>
                                                                        <td>{monthData[parseInt(row?.month)]}-{row?.year}</td>
                                                                        <td>{row?.opening_balance || '---'}</td>
                                                                        <td>{row?.leave_accrued || '---'}</td>
                                                                        <td>{row?.leave_taken || '---'}</td>
                                                                        <td>{row?.closing_balance || '---'}</td>
                                                                    </tr>
                                                                )
                                                            })}
                                                        </tbody>}

                                                </table> */}
                                                <div className="container mt-4">
                                                    <div className="row">
                                                        {teamLeavesBalance?.length === 0 ?
                                                        <div>
                                                            <NoRecords />
                                                        </div>               
                                                        :
                                                        teamLeavesBalance.map((emp, index) => (
                                                        <div className="col-md-4 mb-4" key={index}>
                                                            <div
                                                                className="card shadow border-1"
                                                                style={{
                                                                borderRadius: "12px",
                                                                background: "#f8f9fa",
                                                                }}
                                                            >
                                                                <div className="card-body">

                                                                {/* Employee Name + Code */}
                                                                <div className="d-flex justify-content-between align-items-center mb-2">
                                                                    <h5 className="card-title fw-bold text-dark mb-0">
                                                                    {emp.employee_name}
                                                                    </h5>
                                                                    <span className="badge bg-dark">{emp.employee_code}</span>
                                                                </div>

                                                                <hr className="my-3" />

                                                                <ul className="list-group list-group-flush">
                                                                    {emp.leave_data.map((leave, i) => {

                                                                    // multi-color mapping
                                                                    const colors = ["primary", "success", "warning", "danger", "info"];
                                                                    const colorClass = colors[i % colors.length]; 

                                                                    return (
                                                                        <li
                                                                        className="list-group-item"
                                                                        key={i}
                                                                        style={{
                                                                            background: "#ffffff",
                                                                            borderRadius: "10px",
                                                                            marginBottom: "10px",
                                                                            border: "1px solid #e0e0e0",
                                                                        }}
                                                                        >
                                                                        <div className="d-flex justify-content-between align-items-center">
                                                                            <strong className={`text-${colorClass}`}>
                                                                            {leave.leave_type_name}
                                                                            </strong>

                                                                            <span className={`badge bg-${colorClass}`}>
                                                                            {leave.emp_current_balance} days
                                                                            </span>
                                                                        </div>

                                                                        <div
                                                                            className="mt-1"
                                                                            style={{
                                                                            fontSize: "12px",
                                                                            color: "#6c757d",
                                                                            fontWeight: 500,
                                                                            }}
                                                                        >
                                                                            Pending Approval:{" "}
                                                                            <span className="badge bg-secondary">
                                                                            {leave.emp_pending_leave}
                                                                            </span>
                                                                        </div>
                                                                        </li>
                                                                    );
                                                                    })}
                                                                </ul>
                                                                </div>
                                                            </div>
                                                            </div>

                                                        ))
                                                        }
                                                         
                                                    </div>
                                                </div>
                                            </div>
                                            {/* <div className="d-flex justify-content-between align-items-center w-100 py-2 px-2" >
                                                <button disabled={pagination?.prev === false && pagination?.loadingList === false ? true : false} type="button" onClick={() => handlePrev()} className={`btn btn-warning btn-label waves-effect waves-light`}><i className="ri-arrow-left-line label-icon align-middle fs-16 me-2" /> Previous</button>
                                                <div className='col-md-4' style={{ display: 'flex', alignItems: 'center' }}>
                                                    {
                                                        <small>Total Records: {pagination?.total_records} | Total Pages: {pagination?.total_pages} | Current Page: {pagination?.page}</small>
                                                    }
                                                </div>
                                                <div className='col-md-2'>
                                                    <select className="form-select" onChange={(e) => handleChange(e)}>
                                                        {Array.from({ length: pagination?.total_pages }, (_, i) => (
                                                            <option selected={pagination?.page === i + 1} key={i} value={i + 1}>Page {i + 1}</option>
                                                        ))}
                                                    </select>
                                                </div>
                                                <div className="col-md-2">
                                                    <select className="form-select" onChange={(e) => handleLimitChange(e)} value={pagination?.limit}>
                                                        {limitOptions.map((option) => (
                                                            <option key={option} value={option}>
                                                                Limit {option}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                                <button disabled={pagination?.next === false && pagination?.loadingList === false ? true : false} type="button" onClick={() => handleNext()} className={`btn btn-primary btn-label waves-effect right waves-light`}><i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2" /> Next</button>
                                            </div> */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div >


                    </div>
                </div > :
                <div className='d-flex justify-content-center align-items-center' style={{ height: "90vh" }}>
                    <div className="text-center">
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </div>
                </div>

            }
        </>
    );
}

export default TeamLeavesBalance;
